import { LanguageCode } from './internationalization.types';

const INTL_CODE_OVERRIDES: Partial<Record<LanguageCode, string>> = {
  // Renders "Chinese (Simplified)"
  [LanguageCode.ZH]: 'zh-Hans',
  // Renders "Chinese (Simplified)"
  [LanguageCode.ZH_TW]: 'zh-Hant',
  // Renders "Norwegian".
  [LanguageCode.NB]: 'no',
};

export function getLanguageCode(localeCode: string): LanguageCode {
  return (localeCode?.split(/[_|-]/)[0] as LanguageCode) || null;
}

export function getLanguageName(language: string, languageCode: LanguageCode) {
  const intlCode = INTL_CODE_OVERRIDES[languageCode] ?? languageCode;

  const languageName = new Intl.DisplayNames([language], {
    type: 'language',
    languageDisplay: 'standard',
  }).of(intlCode);

  return (
    (languageName ?? '').charAt(0).toUpperCase() + (languageName ?? '').slice(1)
  );
}
